export default __webpack_public_path__ + "static/media/29.d97aa8b0.png";